import _toConsumableArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import { Chart, registerables } from '../dist/chart.esm';
Chart.register.apply(Chart, _toConsumableArray(registerables));
export default Chart;